import { render, staticRenderFns } from "./ClientGroupsMembersList.vue?vue&type=template&id=bf7b2fec&scoped=true&"
import script from "./ClientGroupsMembersList.vue?vue&type=script&lang=js&"
export * from "./ClientGroupsMembersList.vue?vue&type=script&lang=js&"
import style0 from "./ClientGroupsMembersList.vue?vue&type=style&index=0&id=bf7b2fec&lang=scss&scoped=true&"
import style1 from "./ClientGroupsMembersList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf7b2fec",
  null
  
)

export default component.exports